import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";

/** Focused frame for onboarding tasks that intentionally sit outside the operational shell. */
export function LaunchLayout() {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1120,
          mx: "auto",
          px: { xs: 2, sm: 3 },
          py: { xs: 3, lg: 5 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
